import { render } from "./ActualizarTicketComponent.vue?vue&type=template&id=731b8405"
import script from "./ActualizarTicketComponent.vue?vue&type=script&lang=js"
export * from "./ActualizarTicketComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__